import "core-js/modules/es.array.push.js";
import { reactive, toRefs, getCurrentInstance, watch, onMounted, computed } from "vue";
const __default__ = {
  props: {
    tipStatus: {
      type: Boolean,
      default: false
    },
    props: {
      action: {
        type: String,
        default: ''
      }
    }
  },
  setup(props, content) {
    const {
      proxy
    } = getCurrentInstance();
    const state = reactive({
      uploadPercent: "0",
      preUrl: "",
      preName: "",
      isPre: false,
      isClassDrag: false,
      headers: {
        authKey: localStorage.getItem("authKey")
      },
      baseURL: process.env.VUE_APP_BASE_URL,
      fileList: proxy.$attrs['file-list'] || [],
      dir: proxy.$attrs['dir'] || 'new_staff'
    });
    watch(() => proxy.$attrs['file-list'], val => {
      state.fileList = proxy.$attrs['file-list'];
    }, {
      deep: true
    });
    onMounted(() => {
      proxy.$attrs['drag'] ? state.isClassDrag = true : state.isClassDrag = false;
    });
    const handleRemove = file => {
      const uploadFiles = state.fileList;
      state.fileList = [];
      uploadFiles.map(item => {
        if (item.uid != file.uid) {
          state.fileList.push({
            ...item
          });
        }
      });
      content.emit("removeSuccess", state.fileList);
    };
    const handlePreview = file => {
      state.preName = file.name;
      // 上传时预览和上传后预览的数据处理
      if (file.response) {
        state.preUrl = file.response.data.ossSrc || file.url;
      } else {
        state.preUrl = file.request_url || file.url || file.src;
      }
      // 图片和文件处理
      if (proxy.$attrs.listType === "picture") {
        state.isPre = true;
      } else {
        proxy.$downloadFile(state.preUrl, file.name);
      }
    };
    const handleProgress = file => {
      proxy.$attrs.limit === 1 || props.tipStatus ? proxy.$TcMsg({
        type: "loading",
        text: proxy.$t('other.uploading')
      }) : '';
      state.uploadPercent = parseInt(file.percent) - 10 + '%';
      content.emit("isUploadSuccess", false);
    };
    const handleSuccess = (res, uploadFile, uploadFiles) => {
      // 检查文件名的特殊字符，去除并提示存在的第一个特殊字符
      const specialChars = ["'", '"', '?', ':', '&', '*'];
      let tipChar = '';
      for (let char of specialChars) {
        if (uploadFile.name.includes(char)) {
          // console.error('存在特殊字符文件名', uploadFile.name)
          tipChar = char;
          uploadFile.name = uploadFile.name.replace(/['"?:&*]/g, '');
          break;
        }
      }
      if (res.code == 0) {
        state.fileList.push({
          ...res.data,
          name: uploadFile.name,
          uid: uploadFile.uid,
          url: res.data.ossSrc
        });
        if (tipChar) {
          // 提示特殊字符
          proxy.$TcMsg({
            type: "error",
            text: `${proxy.$t('other.The_file_name_cannot_contain_special_characters')}：\\  ${tipChar} \\ `,
            time: 2000
          });
        } else if (proxy.$attrs.limit === 1 || props.tipStatus) {
          // 提示上传成功
          proxy.$TcMsg({
            type: "success",
            text: proxy.$t('other.upload_successfully'),
            time: 500
          });
        }
      } else {
        let index = uploadFiles.findIndex(item => item.uid == uploadFile.uid);
        uploadFiles.splice(index, 1);
        proxy.$TcMsg({
          type: "error",
          text: res.error
        });
      }
      content.emit("uploadSuccess", state.fileList);
      content.emit("isUploadSuccess", true);
      // console.log('上传成功state.fileList', state.fileList);
    };
    const downloadPic = () => {
      proxy.$downloadFile(state.preUrl, state.preName);
    };

    // 上传的文件超出limit
    const handleExceed = () => {
      proxy.$TcMsg({
        type: "error",
        text: '仅支持上传' + proxy.$attrs.limit + '个文件',
        time: 1500
      });
    };
    const uploadAction = computed(() => {
      return props.action || state.baseURL + 'mx/v1/upload/Oss/uploadData';
    });
    return {
      ...toRefs(state),
      uploadAction,
      handlePreview,
      handleRemove,
      downloadPic,
      handleProgress,
      handleSuccess,
      handleExceed
    };
  }
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
  _useCssVars(_ctx => ({
    "6e600968": _ctx.uploadPercent,
    "3517da84": _ctx.draggerWidth
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;